import React, {memo, useMemo} from "react";
import {InfoBox} from "@react-google-maps/api";
import '@components/module-components/POSMap/pos-map.scss';

type Position = google.maps.LatLng;

interface InfoBoxOptions {
  alignBottom?: boolean;
  boxClass?: string;
  boxStyle?: Partial<CSSStyleDeclaration>;
  closeBoxMargin?: string;
  closeBoxURL?: string;
  content?: string | Node;
  disableAutoPan?: boolean;
  enableEventPropagation?: boolean;
  infoBoxClearance?: google.maps.Size;
  isHidden?: boolean;
  maxWidth?: number;
  pixelOffset?: google.maps.Size;
  position?: google.maps.LatLng;
  pane?: keyof google.maps.MapPanes;
  visible?: boolean;
  zIndex?: number;
}

interface CloseIconProps {
  onClick: () => void;
}

const CLOSE_ICON_PATH_STYLE = {
  fill: 'none',
  stroke: 'rgba(0,0,0,.87)',
  strokeWidth: 2
};


const CloseIcon: React.FC<CloseIconProps> = ({onClick}) => (
  <svg
    className="close-icon"
    xmlns="http://www.w3.org/2000/svg"
    width="18.414"
    height="18.414"
    onClick={onClick}
    viewBox="0 0 18.414 18.414"
  >
    <g transform="translate(-1.893 4.092)">
      <g transform="translate(3 -1)">
        <path d="M17 0L0 17" style={CLOSE_ICON_PATH_STYLE} transform="translate(-.4 -2.385)"/>
        <path d="M0 0L17 17" style={CLOSE_ICON_PATH_STYLE} transform="translate(-.399 -2.385)"/>
      </g>
    </g>
  </svg>
);

interface MarkerInfoBoxProps {
  position: Position;
  isHover?: boolean;
  children: React.ReactNode;
  onClose?: () => void;
  onInfoboxHover?: () => void;
  onInfoboxMouseOut?: () => void;
}

const INFO_BOX_BASE_OPTIONS: InfoBoxOptions = {
  disableAutoPan: true,
  enableEventPropagation: true
};

const MarkerInfoBox: React.FC<MarkerInfoBoxProps> = memo(({
                                                            position,
                                                            isHover,
                                                            children,
                                                            onClose,
                                                            onInfoboxHover,
                                                            onInfoboxMouseOut
                                                          }) => {
  const options = useMemo(() => ({
    ...INFO_BOX_BASE_OPTIONS,
    boxClass: isHover ? 'map-list-manufacturer' : 'map-list-click-manufacturer',
    position: position instanceof google.maps.LatLng
      ? position
      : new google.maps.LatLng(position.lat, position.lng),
    closeBoxURL: '',
  }), [position, isHover]);

  return (
    <InfoBox
      options={options}
      onDomReady={() => {

      }}
      zIndex={isHover ? undefined : 999}
    >
      <div className="marker-info-container"
           onMouseEnter={onInfoboxHover}
           onMouseLeave={onInfoboxMouseOut}>
        {!isHover && onClose && <CloseIcon onClick={onClose}/>}
        <ul className="marker-info-content">{children}</ul>
      </div>
    </InfoBox>
  );
});


export default MarkerInfoBox;